import React from "react";
import * as PropTypes from "prop-types";
import { css } from "@emotion/css";
import { managedLabeledValuePropType } from "../../propTypes";
import Checkbox from "@mui/material/Checkbox";
import LinearProgress from "@mui/material/LinearProgress";
// import DeleteIcon from "@mui/icons-material/Delete";
// import List from "@mui/material/List";
// import ListItem from "@mui/material/ListItem";
// import ListItemText from "@mui/material/ListItemText";

const classes = {
    table: css`
        border-collapse: collapse;
        // width: 100%;

        thead,
        tbody {
            display: block;
        }

        tbody {
            height: auto;
            min-height: 125px;
            display: block;
            max-height: 500px;
            overflow-y: auto; /* Trigger vertical scroll */
            overflow-x: hidden; /* Hide the horizontal scroll */
        }

        tbody {
            /* height: 600px; */
            /* overflow-y: auto; /* Trigger vertical scroll */
            /* overflow-x: hidden; /* Hide the horizontal scroll */
        }

        tr td:nth-child(1),
        tr th:nth-child(1) {
            width: 40px;
        }

        tr td:nth-child(2),
        tr th:nth-child(2) {
            width: 600px;
            word-break: break-all;
        }

        tr td:nth-child(3),
        tr th:nth-child(3) {
            width: 65px;
            text-align: center;
        }

        tr td:nth-child(4),
        tr th:nth-child(4) {
            width: 65px;
            text-align: center;
        }

        tr td:nth-child(5),
        tr th:nth-child(5) {
            width: 40px;
            text-align: center;
        }

        tr td:nth-child(6),
        tr th:nth-child(6) {
            width: 20px;
            text-align: center;
        }

        td,
        th {
            border: 1px solid #ddd;
            padding: 2px 8px;
            font-size: 16px;
        }

        tr:nth-child(even) {
            //   background-color: #f2f2f2;
        }

        tr:hover {
            background-color: #ddd;
        }

        th {
            text-align: left;
            background-color: #0d47a1;
            color: white;
        }
    `,
    checkBox: css`
        padding: 0;
    `,
    item: css`
        padding: 4px 0;
    `,
    deleteIcon: css`
        &:hover {
            cursor: pointer;
        }
    `,
    progress: css`
        margin: 15px 0 5px;
    `,
};

const useFixHTMLTableHeaders = (tableRef, items) => {
    React.useEffect(() => {
        if (tableRef) {
            if (items.length > 0) {
                setTimeout(() => {
                    const current = tableRef.current;
                    const TRs = current.querySelectorAll("tr");

                    const headerRow = TRs[0];
                    const dataRow = TRs[1];

                    if (dataRow) {
                        const TDs = dataRow.querySelectorAll("td");
                        const widths = [...TDs].map((x) => x.offsetWidth);
                        const THs = headerRow.querySelectorAll("th");
                        [...THs].forEach((x, i) => (x.width = widths[i]));
                    }
                }, 50); // NOTE: Needed for offsetWidth to include padding
            }
        }
    }, [tableRef, items]);
};

const ManageDataTableRuns = (props) => {
    const tableRef = React.useRef(null);

    useFixHTMLTableHeaders(tableRef, props.items);

    //   const handleDeleteClick = (item) => () => {
    //     props.onToggleItem(item.value);
    //     // setTimeout(() => {
    //     //   props.onDeleteDatabases();
    //     // }, 1000);
    //   };

    if (props.deleting) {
        return (
            <div className={classes.progress}>
                <LinearProgress />
            </div>
        );
    }

    return (
        <table
            className={classes.table}
            ref={tableRef}
        >
            <thead>
                <tr>
                    <th>{}</th>
                    <th>Name</th>
                </tr>
            </thead>
            <tbody>
                {props.items.map((item) => (
                    <tr key={item.label}>
                        <td>
                            <Checkbox
                                checked={props.selectedItemValues.includes(item.value)}
                                className={classes.checkBox}
                                onChange={() => {
                                    props.onToggleItem(item.value);
                                }}
                            />
                        </td>
                        <td>{item.label}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

ManageDataTableRuns.propTypes = {
    items: PropTypes.arrayOf(managedLabeledValuePropType).isRequired,
    selectedItemValues: PropTypes.arrayOf(PropTypes.string).isRequired,
    onToggleItem: PropTypes.func.isRequired,
};

export default ManageDataTableRuns;
